<div class="grid">
	<div class="col-12">
		<app-input
			type="text"
			label="E-mail:"
			id="email"
			[disabled]="success"
			[(value)]="email"
		/>
	</div>
	<div class="col-12 mb-2" *ngIf="showYearDrop">
		<app-select
			class="w-full"
			label="Ano:"
			[options]="years"
			id="year"
			[disabled]="success"
			[(value)]="year"
		/>
	</div>
	<div class="col-12 mt-4">
		<app-button
			class="w-full"
			caption="Recuperar"
			icon="fa fa-history"
			[disabled]="loading"
			[loading]="loading"
			type="success"
			(action)="recover()"
		/>
	</div>
	<div class="col-12" *ngIf="loading">
		<app-big-loader />
	</div>
	<div class="col-12 mt-4" *ngIf="success">
		<app-alert-message
			type="success"
			icon="fa fa-check-circle"
		>
			A lista será enviada para o e-mail {{email}}.<br/><br/>
			Devido a limitações no servidor, ela pode levar entre alguns minutos e algumas horas para chegar.
		</app-alert-message>
	</div>
</div>
